import { render, staticRenderFns } from "./ShipmentQuery.vue?vue&type=template&id=70d9edb2&scoped=true&"
import script from "./ShipmentQuery.vue?vue&type=script&lang=js&"
export * from "./ShipmentQuery.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentQuery.vue?vue&type=style&index=0&id=70d9edb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9edb2",
  null
  
)

export default component.exports